import { BooleanOrEmpty } from "types/Common";
import ObjectUtil from "./ObjectUtil";

export default class BooleanUtil {
  public static toBoolean(value: any): boolean {
    if (value == null) {
      return value;
    }

    if (typeof value === "string") {
      const valueLowerCase = value.toLowerCase();

      return valueLowerCase === "true" || valueLowerCase === "t" || valueLowerCase === "yes" || valueLowerCase === "y";
    }

    if (typeof value === "boolean") {
      return value === true;
    }

    if (typeof value === "number") {
      return value === 1;
    }

    return ObjectUtil.undefined;
  }

  public static toBooleanOrEmpty(value: any): BooleanOrEmpty {
    if (value != null && value !== "") {
      return this.toBoolean(value);
    }

    return "";
  }
}
